import { ROW_CLASS_NAME, TABLE_CLASS_NAME } from '../constants';

const EXPANDABLE = 'expandable';

export const EXPANDABLE_TABLE = `${TABLE_CLASS_NAME}--${EXPANDABLE}`;
export const EXPANDABLE_ROW = `${ROW_CLASS_NAME}--${EXPANDABLE}`;
export const EXPANDED_ROW = `${ROW_CLASS_NAME}--expanded`;
